<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="fb_pjcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fb_pjcode || "项目单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.fb_pjcode }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_dename">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_dename }}
          </div>
        </div>
        <employee-field
          :label="customLabel.fb_pjemname || '项目负责人'"
          v-model="form.main.fb_pjemname"
          @select="onSelectEmployee"
          slot="fb_pjemname"
        />

        <div class="weui-cell" slot="pj_emtel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_emtel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_emtel }}
          </div>
        </div>

        <phase-field
          :label="customLabel.fb_ppname || '项目阶段'"
          v-model="form.main.fb_ppname"
          @select="onSelectPhase"
          :extraParams="{
            mode: 'DETAIL',
            size: 20,
          }"
          slot="fb_ppname"
        />
        <div class="weui-cell" slot="pp_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pp_emname || "阶段负责人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pp_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_end_date">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_end_date || "项目计划完成日期"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd'">
            {{ form.main.pj_end_date }}
          </div>
        </div>
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>配置需求{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-cell" slot="pb_task">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pb_task || "问题点"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.pb_task"
                  placeholder="请填写"
                />
              </div>
            </div>
            <date-field
              slot="pb_planenddate"
              :label="customLabel.pb_planenddate || '要求完成日期'"
              v-model="item.pb_planenddate"
            />
          </custom-layout>
          <a
            href="javascript:"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.fb_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import PhaseField from "@/components/field/PhaseField.vue";
import FileField from "@/components/field/FileField.vue";
import DateField from "@/components/field/DateField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    EmployeeField,
    PhaseField,
    FileField,
    DateField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/plm/problemfeedback",
      codeField: "fb_code",
      statusField: "fb_statuscode",
      caller: "PlmProblemFeedback",
      xtype: "plm-problemfeedback-formpanel",
      form: {
        main: {
          fb_pjid: null,
          fb_pjcode: null,
          pj_dename: null,
          fb_pjemname: null,
          pj_emtel: null,
          fb_ppname: null,
        },
        items: [
          {
            pb_pjid: null,
            pb_ptid: null,
            pb_task: null,
            pb_planenddate: null,
            pt_emname: null,
            pt_code: null,
            pt_taskstatus: null,
            pt_result: null,
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  methods: {
    getData() {
      var me = this,
        form = me.$route.params.form;
      if (form) {
        var main = me.$route.params.form.main;
        me.form.main.fb_pjcode = main.ta_pjcode;
        me.form.main.fb_pjid = main.ta_pjid;
        me.form.main.pj_dename = main.pj_dename;
        me.form.main.fb_pjemid = main.pj_emid;
        me.form.main.fb_pjemname = main.pj_emname;
        me.form.main.pj_emtel= main.pj_emtel;
        me.form.main.fb_ppname = main.ta_rpname;
        me.form.main.pp_emid = main.pp_emid;
        me.form.main.pp_emname = main.pp_emname;
        me.form.main.pj_end_date = main.pj_end_date
        me.form.main.fb_taid = main.id;
        me.form.main.fb_tacode = main.ta_code;
      }
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.fb_pjemid = selection.id;
    },
    onSelectPhase(selection) {
      var me = this,
        main = me.form.main;
      main.fb_ppid = selection.pp_id;
      main.fb_pjid = selection.pj_id;
      main.pj_dename = selection.pj_dename;
      main.fb_pjcode = selection.pj_code;
      main.fb_pjemid = selection.pj_emid;
      main.fb_pjemname = selection.pj_emname;
      main.pj_emtel = selection.pj_emtel;
      main.pp_emid = selection.pp_emid;
      main.pp_emname = selection.pp_emname;
      main.pj_end_date = selection.pj_end_date;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.fb_pjemname) {
        me.$weui.topTips("请选择项目负责人", 2000);
      }else {
        if (!items) {
          checked = true;
        } else {
          var count = 0;
          items.forEach(function (item) {
            if (!item.pb_task) {
              me.$weui.topTips(`第${count + 1}行未填写问题点`, 2000);
              return false;
            } else {
              count++;
              item.pb_detno = count;
            }
          });
          checked = count == items.length;
        }
      }
      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        pb_pjid: null,
        pb_ptid: null,
        pb_task: null,
        pb_planenddate: null,
        pt_emname: null,
        pt_code: null,
        pt_taskstatus: null,
        pt_result: null,
      });
    },
  },
};
</script>